// 测试环境配置
import { isJwInlandApp, isJwIntlApp } from "../utils/app/env";

const deployDir = "/";
const hostname = "http://www.test.school.basejy.com";
const appUrl = `${hostname}`;
const JW_APP_URL = `${hostname}`;

export default {
  SERVER_URL: "http://api.test.school.basejy.com", // 后端服务域名
  BASE_SALES_SERVER_URL: "http://ttfs.154basejy.com", // base-sales 网关（勿走智校 SERVER_URL）
  BASE_USER_BEHAVIOR_SERVER_URL: "http://ttfs.154basejy.com",
  DEPLOY_DIR: deployDir, // 项目部署的目录
  APP_URL: appUrl, // 本项目访问地址
  ACTIVITY_MARKET_ORIGIN: hostname,
  H5_STATIC_SERVER_URL: "https://tencent.dev-env.basejy.com", // h5页面访问地址
  WX_APPID: "wx99bc4493f44c706f", // 微信公众号appid
  WX_MP_APP_ID: "wx99bc4493f44c706f", // 微信公众号扫码登录使用
  SHOW_MAI_DIAN_LOG: true, // 是否打印埋点日志到浏览器控制台
  ALLOW_MOBILE_LOGIN_PAGE: true, // 是否打开手机登录页面
  JW_APP_URL: JW_APP_URL,
  JW_KUAIPK_APP_URL: "http://v5.dev.basejy.com/kuaipk",
  JW_KUAIJW_APP_URL: "http://v5.dev.basejy.com/jw-inland",
  JW_KUAIJK_APP_URL: `${JW_APP_URL}-kuaijk`,
  JW_KUAIXK_APP_URL: `${JW_APP_URL}-kuaixk`,
  JW_KUAIFB_APP_URL: `${JW_APP_URL}-kuaifb`,
  JW_KUAICJ_APP_URL: "http://v5.dev.basejy.com/kuaicj",
  AI_CHATBOT_BASE_URL: "http://ttfs.154basejy.com/base-chatbot", // AI聊天服务地址（测试环境）
  AI_CUSTOMER_BASE_URL: "http://aicustomer.dev.basejy.com", // AI客服服务地址
  KUAI_JW_CONSULTATION_URL: "http://www.test.school.basejy.com/#/basejw/kuaijw-consultation",
};
